// The CSP in firebase.json sets `require-trusted-types-for 'script'; trusted-types default`.
// Firebase Auth's `signInWithPopup` flow loads Google's gapi loader via
// <script src="https://apis.google.com/js/api.js">, which the browser blocks under that CSP
// unless a 'default' Trusted Types policy sanctions the script URL (the "This document requires
// 'TrustedScriptURL' assignment" console error). Once loaded, that same gapi library also
// bootstraps its iframe relay by assigning raw HTML strings (e.g. to `.innerHTML`), which needs
// a `createHTML` hook on the same 'default' policy or the browser blocks it too (the "This
// document requires 'TrustedHTML' assignment" console error) — this broke Google sign-in even
// after the script-URL policy alone was added. Since our own source never uses innerHTML/
// dangerouslySetInnerHTML, passing HTML through unsanitized here doesn't add first-party XSS
// risk; the origin allowlist below is what keeps arbitrary script URLs out.
interface MinimalTrustedTypesWindow {
  trustedTypes?: {
    createPolicy(
      name: string,
      options: {
        createScriptURL?: (url: string) => string;
        createHTML?: (html: string) => string;
      }
    ): unknown;
  };
}

const ALLOWED_SCRIPT_ORIGINS = ["https://apis.google.com/", "https://accounts.google.com/"];

const trustedTypes = (window as unknown as MinimalTrustedTypesWindow).trustedTypes;
if (trustedTypes) {
  try {
    trustedTypes.createPolicy("default", {
      createScriptURL: (url: string) => {
        if (ALLOWED_SCRIPT_ORIGINS.some((origin) => url.startsWith(origin))) return url;
        throw new Error(`Blocked untrusted script URL: ${url}`);
      },
      createHTML: (html: string) => html,
    });
  } catch {
    // A 'default' policy may already exist (e.g. Vite HMR in dev) — ignore.
  }
}
